import { Component, Input, OnInit } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { PlayerService } from "app/services";
import { PlayerDto } from "../../../models";

@Component({
    selector: 'player-modal',
    templateUrl: './player.modal.html',
    styleUrls: ['./player.modal.scss'],
})
export class PlayerModal implements OnInit{
    @Input() squadPlayers: PlayerDto[];

    @Input() substitutionPlayers: PlayerDto[];

    @Input() resevePlayers: PlayerDto[];
    
    @Input() selectedPlayer: PlayerDto;

    filters = {
        gk: false,
        sw: false,
        df: false,
        dm: false,
        mf: false,
        am: false,
        fw: false,
        l: false,
        c: false,
        r: false
    }

    filteredSquad: PlayerDto[];
    filteredSubstitutions: PlayerDto[];
    filteredReseves: PlayerDto[];

    constructor(public activeModal: NgbActiveModal, private playerService: PlayerService) {
    }

    ngOnInit(): void {
        this.filterPlayers();
    }

    getPlayerName(player: PlayerDto) {
        let result = (player.name ? player.name[0] + ". " : "" )+ player.surname;

        return result.trim();
    }

    selectPlayer(player: PlayerDto) {
        this.activeModal.close(player);
    }

    getPlayerPositionLabel(player: PlayerDto) {
        return this.playerService.formatPlayerPosition(player);
    }

    toggleGk() {
        this.filters.gk = !this.filters.gk;
        this.filterPlayers();
    }

    toggleSW() {
        this.filters.sw = !this.filters.sw;
        this.filterPlayers();
    }

    toggleDF() {
        this.filters.df = !this.filters.df;
        this.filterPlayers();
    }

    toggleDM() {
        this.filters.dm = !this.filters.dm;
        this.filterPlayers();
    }

    toggleMF() {
        this.filters.mf = !this.filters.mf;
        this.filterPlayers();
    }

    toggleAM() {
        this.filters.am = !this.filters.am;
        this.filterPlayers();
    }

    toggleFW() {
        this.filters.fw = !this.filters.fw;
        this.filterPlayers();
    }

    toggleL() {
        this.filters.l = !this.filters.l;
        this.filterPlayers();
    }

    toggleC() {
        this.filters.c = !this.filters.c;
        this.filterPlayers();
    }

    toggleR() {
        this.filters.r = !this.filters.r;
        this.filterPlayers();
    }

    private filterPlayers() {
        this.filteredSquad = [];
        this.filteredSubstitutions = [];
        this.filteredReseves = [];

        if (this.squadPlayers) {
            this.squadPlayers.forEach(item => {
                if (this.isFilterEmptyOrFull() || this.isPlayerMatchFilter(item)) {
                        this.filteredSquad.push(item);
                }
            });
        }

        if (this.substitutionPlayers) {
            this.substitutionPlayers.forEach(item => {
                if (this.isFilterEmptyOrFull() || this.isPlayerMatchFilter(item)) {
                    this.filteredSubstitutions.push(item);
                }
            });
        }

        if (this.resevePlayers) {
            this.resevePlayers.forEach(item => {
                if (this.isFilterEmptyOrFull() || this.isPlayerMatchFilter(item)) {
                    this.filteredReseves.push(item);
                }
            });
        }
    }

    private isPlayerMatchFilter(player: PlayerDto): boolean {
        if (player.isGK && this.filters.gk)
            return true;

        let isPosMath = false;

        if ((!this.filters.l && !this.filters.r && !this.filters.c) ||
            ((player.isLeft && this.filters.l) || (player.isRight && this.filters.r) || (player.isCenter && this.filters.c)))
            isPosMath = true;

        if (!isPosMath)
            return false;

        if (!this.filters.gk && !this.filters.sw && !this.filters.df && !this.filters.dm && !this.filters.mf && !this.filters.am && !this.filters.fw)
            return true;

        if ((player.isSW && this.filters.sw) || (player.isDF && this.filters.df) || (player.isDM && this.filters.dm)
            || (player.isMF && this.filters.mf) || (player.isAM && this.filters.am) || (player.isFW && this.filters.fw))
            return true;

        return false;
        
    }

    private isFilterEmptyOrFull(): boolean {
        return (!this.filters.gk && !this.filters.sw && !this.filters.df && !this.filters.dm
        && !this.filters.mf && !this.filters.am && !this.filters.fw && !this.filters.l && !this.filters.c && !this.filters.r) ||
            (this.filters.gk && this.filters.sw && this.filters.df && this.filters.dm
                && this.filters.mf && this.filters.am && this.filters.fw && this.filters.l && this.filters.c && this.filters.r);
    }
}